import React, { useState } from 'react';
import './estilo.css';

const BannerParque = (props) => {
    const [open, setOpen] = useState(false);

    return(
        <>
            <div className="banner-dengue__container">
                <img src={props.ulrBanner} alt={props.altTxt} title={props.altTxt} className="logo-banner"/>
            </div>
        </>
    );
}

export default BannerParque;